import DealerMapCheckerTabs from "./Checker/DealerMapCheckerTabs";
import DealerMapMakerTabs from "./Maker/DealerMapMakerTabs";


function DealerMappingMain(){
     const getRole = localStorage.getItem("cosmosProjectRole");     

    return (
        <>
        {getRole === "maker" ?
        <DealerMapMakerTabs />
        : 
        <DealerMapCheckerTabs />}
        </>

    )
}

export default DealerMappingMain;